var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmileOrangeNoBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.54771,
    stroke: "#F6931E",
    strokeWidth: 0.904574
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42834 6.68344C4.26018 6.84614 4.14104 7.05025 4.08115 7.27269L3.60412 7.27269C3.67347 6.93087 3.84385 6.61497 4.09665 6.36788C4.42407 6.04786 4.86373 5.86867 5.32158 5.86867C5.77942 5.86867 6.21909 6.04786 6.54651 6.36788C6.7993 6.61497 6.96968 6.93087 7.03903 7.27269L6.56201 7.27269C6.50211 7.05025 6.38297 6.84614 6.21481 6.68344C5.97523 6.45165 5.65493 6.32206 5.32158 6.32206C4.98822 6.32206 4.66792 6.45165 4.42834 6.68344Z",
    fill: "#F6931E",
    stroke: "#F6931E",
    strokeWidth: 0.603049
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.194 6.68442C10.0258 6.84712 9.90667 7.05123 9.84677 7.27367L9.36974 7.27367C9.43909 6.93184 9.60948 6.61595 9.86227 6.36886C10.1897 6.04883 10.6294 5.86965 11.0872 5.86965C11.545 5.86965 11.9847 6.04883 12.3121 6.36886C12.5649 6.61595 12.7353 6.93184 12.8047 7.27367L12.3276 7.27367C12.2677 7.05123 12.1486 6.84712 11.9804 6.68442C11.7409 6.45262 11.4206 6.32304 11.0872 6.32304C10.7538 6.32304 10.4335 6.45262 10.194 6.68442Z",
    fill: "#F6931E",
    stroke: "#F6931E",
    strokeWidth: 0.603049
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1769 11.7533C7.83693 11.7527 7.51102 11.6174 7.27061 11.377C7.10239 11.2088 6.98564 10.9987 6.9305 10.7713H6.45262C6.51427 11.1247 6.68334 11.4533 6.94043 11.7104C7.26948 12.0394 7.71576 12.2243 8.1811 12.2243C8.64644 12.2243 9.09272 12.0394 9.42177 11.7104C9.67886 11.4533 9.84793 11.1247 9.90958 10.7713H9.43169C9.41588 10.8365 9.39494 10.9006 9.36899 10.9628C9.30391 11.119 9.20863 11.2607 9.08862 11.38C8.96861 11.4992 8.82624 11.5936 8.66966 11.6576C8.51329 11.7216 8.34584 11.7541 8.1769 11.7533ZM8.1769 11.7533C8.17668 11.7533 8.17646 11.7533 8.17624 11.7533L8.17789 11.4517L8.17756 11.7533C8.17734 11.7533 8.17712 11.7533 8.1769 11.7533Z",
    fill: "#F6931E",
    stroke: "#F6931E",
    strokeWidth: 0.603049
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileOrangeNoBackground);
export default __webpack_public_path__ + "static/media/smileOrange_noBackground.7f891275a2d880b4d368e11694fbb888.svg";
export { ForwardRef as ReactComponent };